import { gql } from '@apollo/client';

export const GET_PATIENTS = gql`
  query GetPatientsForAutocomplete(
    $page: Int!
    $perPage: Int!
    $withCarePlan: Boolean
    $filter: GqlPatientFilter!
  ) {
    user {
      patient {
        patientPagination(
          page: $page
          perPage: $perPage
          withCarePlan: $withCarePlan
          filter: $filter
        ) {
          pageInfo {
            totalItems
            page
            perPage
            totalPages
            hasNextPage
            hasPreviousPage
          }
          items {
            id
            name {
              firstName
              lastName
            }
            email
            gender
            phone
            birthDate
            photoUrl
            isActive
            isSelfRegistered
            lastActivity
            birthPlace {
              country
              city
              address
              zipcode
            }
            carePlans {
              items {
                title
                planDefinitionId
                patientId
                startDate
                engagement
                engagementRatio
                currentDay
                endDay
                status
              }
            }
          }
        }
      }
    }
  }
`;
